import { render } from "./DocumentSignAuthentication.vue?vue&type=template&id=89495ef6&lang=pug"
import script from "./DocumentSignAuthentication.vue?vue&type=script&lang=js"
export * from "./DocumentSignAuthentication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__